import type { PublicFlowImageUrlResponse } from "@repo/shared/types";
import { getWithToken } from "../_client";

/**
 * GET /public/flow/image/component/:componentId — a URL the browser can load
 * for an `image` component on the public flow (QL-429).
 */
export function getPublicFlowImageUrl(componentId: string, token: string) {
  return getWithToken<PublicFlowImageUrlResponse>(
    `/public/flow/image/component/${encodeURIComponent(componentId)}`,
    token,
  );
}
